<script>
    export default {
        props: {
            relatedModelType: String,
            relatedModelId: Number,
            attribute: Object,
        },
        data() {
            return {
                attributeData: null,
            }
        },
        computed: {
        },
        mounted() {
            if (this.attributeData == null) {
                axios.get(Scoop.baseUrl + '/edito/attribute-for-element', {
                    params: {
                        'related_model_type': this.relatedModelType,
                        'related_model_id': this.relatedModelId,
                        'text_attribute_id': this.attribute.id
                    }
                }).then((response) => {
                    this.attributeData = response.data;
                });
            }
        },
        methods: {
        },
    }
</script>

<template>
    <div v-if="attributeData">
        <component :is="'text-attribute-'+attributeData.inputTypeKebab" :data="attributeData" :with-cols="true"></component>
    </div>
</template>
